import { of as observableOf } from 'rxjs';

import { mergeMap, finalize, delay } from 'rxjs/operators';
import { Component, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';

import { TranslateService } from '@ngx-translate/core';
import {
  ProcurementProjectDTO,
  ValidationResultDTO
} from '../../api/plyca-dtos-v2';
import { FormService } from '../../components/forms/form.service';
import { ActionDTO, ActionTypeDTO } from '../../api/plyca-dtos';
import {
  ValidationExecutionDTO
} from '../../api/plyca-dtos-v2';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { ServiceLocator } from '../../ServiceLocator';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

import * as lodash from 'lodash';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { TaskService } from '../../tasks/task.service';

export class SaveDossierData {
  dossier: ProcurementProjectDTO;
  error: any;
  validateFromWarnings: boolean;
  isValidatedOk: boolean;
  message: any;
  popupReturnAction: string;
}

@Component({
  selector: 'saveDossierPopup',
  templateUrl: 'saveDossierPopup.template.html'
})
export class saveDossierPopupComponent extends BaseComponent implements OnDestroy {
  loaded = false;
  title = '';
  message = '';
  loadingMessage = '';
  task;
  stepChange;
  // dossier: Procuremen tProjectDTO;
  data: SaveDossierData;
  lastStep: boolean;
  altaOk = false;
  updateOk = false;
  @Input() showPopUp = true;
  @Input() saving = true;

  errorDto: ValidationResultDTO;
  appConfig: AppConfiguration;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public translate: TranslateService,
    private formService: FormService,
    public router: Router,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService,
    private taskService: TaskService
  ) {
    super();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    //    let dossier = dialog.context['dossier'];
    let dossier = dialogConfig['dossier'];
    let validationContext = dialogConfig['validationContext'];
    this.lastStep = dialogConfig['lastStep'];
    this.data = new SaveDossierData();
    this.data.dossier = dossier;
    let readOnly = false;
    this.loadingMessage = this.translate.instant('GenericDossier.changing');
    this.task = dialogConfig['task'];
    this.stepChange = dialogConfig['stepChange'];
    this.waitService.cancelWaiting();
    if (!readOnly) {
      console.log('tratando expediente', dossier);

      this.saveProject(dossier, validationContext);
    } else {
      this.saving = true;
      this.subscribe(observableOf(true)
        .pipe(

          finalize(() => (this.loaded = true))
        ),
        (resp: boolean) => {
          if (resp) {
            this.altaOk = true;
            this.showPopUp = false;
            this.saving = false;
          } else {
            this.updateOk = true;
            this.showPopUp = false;
            this.saving = false;
          }
        });
    }
  }
  private saveProject(dossier: any, validationContext: any) {
    this.saving = true;
    // si el expediente no tiene identifier es un alta
    if (!dossier.identifier) {
      this.insertDossier(dossier, validationContext);
    } else {
      this.updateDossier(dossier, validationContext);
    }
  }
  private insertDossier(dossier: any, validationContext: any) {
    console.log('CREANDO expediente');
    this.subscribe(this.plycaService
      .createProcurementProject(dossier, validationContext)
      .pipe(mergeMap(_dossier => {
        return this.plycaService.getProcurementProject(_dossier.identifier, '?expand=expansionSet:subclass_complete,availableActions');
      }), finalize(() => {
        if (this.altaOk || this.updateOk) {
          this.loaded = true;
          this.saving = false;
          // Si viene de tarea, o es un modelo no se muestra el inicia tramitacion
          if (this.task || this.stepChange || dossier.documentClass.identifier === this.appConfig.getValue('dossierModel.documentClass')) {
            this.showPopUp = false;
          }
          if (!this.showPopUp) {
            this.close();
          }

          // this.uiService.showSuccess(this.translate.instant('GenericDossier.insert.ok', this.getDossierId(this.data.dossier))
          //  , this.translate.instant('General.info'), 'success');
        }
        else {
          this.loaded = true;
          this.saving = false;
          this.showPopUp = true;
        }
      })),
      (updatedDossier: ProcurementProjectDTO) => {
        this.data.dossier = updatedDossier;
        console.log('expediente creado,', updatedDossier);
        this.altaOk = true;
        this.saving = false;
        this.showPopUp = false;
        this.data.popupReturnAction = 'UPDATEOK';
        this.data.message = this.translate.instant('GenericDossier.created', {
          identifier: this.getDossierId(this.data.dossier)
        });
        this.mostrarTramitaroCerrar();
      }, (error: any) => this.manageServerError(error.error));
  }

  private updateDossier(dossier: any, validationContext: any) {
    console.log('MODIFICANDO expediente');
    this.subscribe(this.plycaService
      .updateProcurementProject(dossier, validationContext)
      .pipe(mergeMap(() => {
        return this.plycaService.getProcurementProject(dossier.identifier, '?expand=expansionSet:subclass_complete,availableActions');
      }), finalize(() => {
        if (this.showPopUp && dossier.documentClass.identifier !== this.appConfig.getValue('dossierModel.documentClass')) {
          this.loaded = true;
          this.saving = false;
        }
        else {
          this.showPopUp = false;
          this.close();
        }
      })),
      x => {
        this.data.dossier = x;
        this.updateOk = true;
        this.saving = false;
        this.showPopUp = false;
        this.data.message = this.translate.instant('GenericDossier.update.ok', {
          identifier: this.getDossierId(this.data.dossier)
        });
        this.mostrarTramitaroCerrar();
      }, (error: any) => this.manageServerError(error.error));
  }

  private mostrarTramitaroCerrar() {
    if (!this.isProjectStartEnabled()) {
      console.log('VALIDAR');
      this.data.validateFromWarnings = true;
    }
    else {
      // Muestra la opción de tramitar
      this.showPopUp = true;
    }
  }

  public getDossierId(dossier: ProcurementProjectDTO): string {
    // return dossier.name ? dossier.name : this.getPropuestaId(dossier);
    return dossier.contractFolderId
      ? dossier.contractFolderId
      : this.getPropuestaId(dossier);
  }

  private getPropuestaId(dossier: ProcurementProjectDTO): string {
    let propuesta = dossier.identifier;
    if (propuesta && propuesta.length > 4) {
      propuesta = propuesta.substring(0, 4) + '/' + propuesta.substring(4);
    }
    return propuesta;
  }

  private manageServerError(error: any) {
    this.data.error = error;
    this.altaOk = false;
    this.updateOk = false;
    this.showPopUp = true;
    this.saving = false;
    let errorMsg: string;
    if (this.formService.isValidationResponse(error)) {
      this.errorDto = error.error as ValidationResultDTO;
      if (error.result === 'FATAL') {
        errorMsg = this.translate.instant('GenericDossier.validation.fatal');
        // Mostrar en el mensaje las validaciones de tipo fatal
        /*const filteredErrors = error.errors.filter(error => error.result === 'FATAL');
        errorMsg = errorMsg + ':<br><ul>';
        filteredErrors.forEach(error => {
          //console.log(error.message); // Imprimir el mensaje de error
          errorMsg += '<li>' + error.message + '</li>';
        });
        errorMsg += '</ul>';*/
      }
    }
    if (!errorMsg) {
      errorMsg =
        ' ' + this.translate.instant('GenericDossier.validation.other');
    }
    this.message = '<i class="fa fa-info fa-2x" aria-hidden="true"></i>';
    if (!this.data.dossier.identifier) {
      if (errorMsg !== undefined && errorMsg != null) {
        this.message = errorMsg;
      } else {
        this.message =
          this.translate.instant('GenericDossier.validation.insert') +
          '<br/><strong>' +
          errorMsg +
          '</strong>';

      }
    } else {
      if (errorMsg !== undefined && errorMsg != null) {
        this.message = errorMsg;
      } else {
        this.message =
          this.translate.instant('GenericDossier.validation.update') +
          '  ' +
          errorMsg;
      }
    }

  }

  close() {
    this.ref.close(this.data);
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  isProjectStartEnabled(): boolean {
    // solamente se habilita la opcion de tramitar si es el ultimo paso y no es un cambio de paso
    return (
      this.data.dossier &&
      this.lastStep &&
      this.getStartProjectAction() != undefined &&
      !this.stepChange
    );
  }



  private getStartProjectAction(): ActionDTO {
    // Hace que se muestre la opción de tramitar en el popup
    let startAction: ActionDTO;
    let dossier = this.data.dossier;
    let actions = dossier.availableActions;
    if (actions) {
      startAction = dossier.availableActions.actions.find(
        (action: ActionDTO) =>
          action.identifier === 'PROJECT_START' && action.enabled
      );
      this.data.dossier.availableActions = actions;
    }
    return startAction;
  }

  initTram() {
    // Ejecutar la tramitación y cerrar

    this.waitService.startWaiting();
    this.loaded = false;
    let dossier = this.data.dossier;
    this.loadingMessage = this.translate.instant('GenericDossier.starting');
    this.subscribe(this.plycaService
      .startProcurementProject(dossier)
      .pipe(
        finalize(() => {
          this.waitService.cancelWaiting();
          this.loaded = true;

        })
      ),
      () => {
        if (this.task && this.task.availableActions && this.task.availableActions.actions && this.task.availableActions.actions.length > 0) {
          // No tiene la accion de despachar
          // De momento se la copiamos de mantener
          let action = this.task.availableActions.actions[0];
          action = lodash.cloneDeep(action);
          action.identifier = ActionTypeDTO.TASK_DISPATCH;
          let url: string;
          url = action.links[0].href;
          url = url.substr(0, url.lastIndexOf('/'));
          url += '/dispatch';
          action.links[0].href = url;
          this.task.availableActions.actions.push(action);

          this.subscribe(this.taskService.dispatchTask(this.task));
        }
        this.data.popupReturnAction = 'TRAMITACIONOK';
        this.close();
      },
      () => {
        this.message = this.translate.instant('GenericDossier.start.error');
        this.data.popupReturnAction = 'TRAMITACIONKO';
        this.close();

      }
    );
  }

  // Métodos para el template del popup

  isAltaOk() {
    return this.altaOk;
  }

  isUpdateOk() {
    return this.updateOk;
  }

  isFormIdPropPlan(): boolean {
    let formId: string;
    if (this.data.dossier && this.data.dossier.formId) {
      formId = this.data.dossier.formId;
    }
    if (formId && formId == 'PROP_PLAN_FE') {
      return true;
    }
    return false;
  }
}
